export default {
  "advertisers.title": "Associez votre marque à l'excellence du tennis camerounais",
  "advertisers.subtitle": "Le Tennis Club de Douala attire l'élite sportive et économique de Douala",
  "advertisers.audience": "Notre Audimat",
  "advertisers.audienceDesc": "Une audience qualifiée et diversifiée pour maximiser l'impact de votre marque",
  "advertisers.audience1": "Membres actifs, familles et compétiteurs",
  "advertisers.audience2": "Milieu d'affaires de Bonanjo et Douala",
  "advertisers.audience3": "Visiteurs internationaux (tournois ITF)",
  "advertisers.audience4": "Communauté sportive d'Afrique centrale",
  "advertisers.offers": "Nos Offres Publicitaires",
  "advertisers.offersDesc": "Des solutions sur mesure pour connecter votre marque à notre communauté premium",
  "advertisers.offer1": "Sponsor Titre de Tournoi",
  "advertisers.offer1Desc": "Logo sur tous les supports, naming rights événement, visibilité internationale",
  "advertisers.offer2": "Banner Digital Site Web",
  "advertisers.offer2Desc": "Emplacements premium sur la homepage et les pages intérieures",
  "advertisers.offer3": "Visibilité Application Mobile",
  "advertisers.offer3Desc": "Encarts publicitaires dans l'app de réservation de courts",
  "advertisers.offer4": "Sponsoring Court",
  "advertisers.offer4Desc": "Naming d'un court — Ex. Court Central — Votre Marque",
  "advertisers.offer5": "Partenariat Équipement",
  "advertisers.offer5Desc": "Visibilité sur le matériel et les tenues officielles du club",
  "advertisers.offer6": "Newsletter Club",
  "advertisers.offer6Desc": "Espace publicitaire dans les communications aux membres",
  "advertisers.form.title": "Devenir Partenaire",
  "advertisers.form.name": "Nom complet",
  "advertisers.form.company": "Entreprise",
  "advertisers.form.email": "Email professionnel",
  "advertisers.form.phone": "Téléphone",
  "advertisers.form.offer": "Offre qui vous intéresse",
  "advertisers.form.message": "Message",
  "advertisers.form.cta": "Envoyer ma demande",
  "advertisers.contact": "Ou contactez-nous directement :",
  "advertisers.cta": "Devenir Partenaire"
}